const allInternalTraxaaRolesData = ['COMPANY_ADMIN', 'COMPANY_OPERATION_USER', 'COMPANY_ACCOUNT_USER'];

export default allInternalTraxaaRolesData;
